// src/utils/matchReference.js
const matchReference = [
  {
    id: "37091",
    roundname: "Opening Round",
    hteam: "Sydney",
    ateam: "Hawthorn",
    aflid: "6966",
  },
  {
    id: "37093",
    roundname: "Opening Round",
    hteam: "Greater Western Sydney",
    ateam: "Collingwood",
    aflid: "6968",
  },
  {
    id: "37094",
    roundname: "Round 1",
    hteam: "Richmond",
    ateam: "Carlton",
    aflid: "6972",
  },
  {
    id: "37095",
    roundname: "Round 1",
    hteam: "Hawthorn",
    ateam: "Essendon",
    aflid: "6971",
  },
  {
    id: "37096",
    roundname: "Round 1",
    hteam: "Geelong",
    ateam: "Fremantle",
    aflid: "6970",
  },
  {
    id: "37097",
    roundname: "Round 1",
    hteam: "Sydney",
    ateam: "Brisbane Lions",
    aflid: "6969",
  },
  {
    id: "37099",
    roundname: "Round 1",
    hteam: "Collingwood",
    ateam: "Port Adelaide",
    aflid: "6974",
  },
  {
    id: "37098",
    roundname: "Round 1",
    hteam: "Western Bulldogs",
    ateam: "North Melbourne",
    aflid: "6973",
  },
  {
    id: "37100",
    roundname: "Round 1",
    hteam: "Adelaide",
    ateam: "St Kilda",
    aflid: "6976",
  },
  {
    id: "37101",
    roundname: "Round 1",
    hteam: "Melbourne",
    ateam: "Greater Western Sydney",
    aflid: "6975",
  },
  {
    id: "37102",
    roundname: "Round 1",
    hteam: "West Coast",
    ateam: "Gold Coast",
    aflid: "6977",
  },
  {
    id: "37103",
    roundname: "Round 2",
    hteam: "Carlton",
    ateam: "Hawthorn",
    aflid: "6978",
  },
  {
    id: "37104",
    roundname: "Round 2",
    hteam: "Western Bulldogs",
    ateam: "Collingwood",
    aflid: "6979",
  },
  {
    id: "37105",
    roundname: "Round 2",
    hteam: "Essendon",
    ateam: "Adelaide",
    aflid: "6981",
  },
  {
    id: "37106",
    roundname: "Round 2",
    hteam: "Port Adelaide",
    ateam: "Richmond",
    aflid: "6980",
  },
  {
    id: "37107",
    roundname: "Round 2",
    hteam: "St Kilda",
    ateam: "Geelong",
    aflid: "6982",
  },
  {
    id: "37108",
    roundname: "Round 2",
    hteam: "Brisbane Lions",
    ateam: "West Coast",
    aflid: "6983",
  },
  {
    id: "37109",
    roundname: "Round 2",
    hteam: "North Melbourne",
    ateam: "Melbourne",
    aflid: "6986",
  },
  {
    id: "37110",
    roundname: "Round 2",
    hteam: "Fremantle",
    ateam: "Sydney",
    aflid: "6985",
  },
  {
    id: "37111",
    roundname: "Round 3",
    hteam: "Essendon",
    ateam: "Port Adelaide",
    aflid: "6984",
  },
  {
    id: "37112",
    roundname: "Round 3",
    hteam: "Carlton",
    ateam: "Western Bulldogs",
    aflid: "6988",
  },
  {
    id: "37113",
    roundname: "Round 3",
    hteam: "Melbourne",
    ateam: "Gold Coast",
    aflid: "6987",
  },
  {
    id: "37114",
    roundname: "Round 3",
    hteam: "St Kilda",
    ateam: "Richmond",
    aflid: "6989",
  },
  {
    id: "37090",
    roundname: "Round 3",
    hteam: "Brisbane Lions",
    ateam: "Geelong",
    aflid: "7753",
  },
  {
    id: "37115",
    roundname: "Round 3",
    hteam: "Hawthorn",
    ateam: "Greater Western Sydney",
    aflid: "6990",
  },
  {
    id: "37116",
    roundname: "Round 3",
    hteam: "Adelaide",
    ateam: "North Melbourne",
    aflid: "6998",
  },
  {
    id: "37117",
    roundname: "Round 3",
    hteam: "West Coast",
    ateam: "Fremantle",
    aflid: "6993",
  },
  {
    id: "37118",
    roundname: "Round 4",
    hteam: "Collingwood",
    ateam: "Carlton",
    aflid: "6991",
  },
  {
    id: "37119",
    roundname: "Round 4",
    hteam: "Geelong",
    ateam: "Melbourne",
    aflid: "6995",
  },
  {
    id: "37120",
    roundname: "Round 4",
    hteam: "Gold Coast",
    ateam: "Adelaide",
    aflid: "6992",
  },
  {
    id: "37121",
    roundname: "Round 4",
    hteam: "Richmond",
    ateam: "Brisbane Lions",
    aflid: "6997",
  },
  {
    id: "37122",
    roundname: "Round 4",
    hteam: "North Melbourne",
    ateam: "Sydney",
    aflid: "6994",
  },
  {
    id: "37123",
    roundname: "Round 4",
    hteam: "Greater Western Sydney",
    ateam: "West Coast",
    aflid: "6996",
  },
  {
    id: "37124",
    roundname: "Round 4",
    hteam: "Port Adelaide",
    ateam: "St Kilda",
    aflid: "7002",
  },
  {
    id: "37125",
    roundname: "Round 4",
    hteam: "Fremantle",
    ateam: "Western Bulldogs",
    aflid: "7001",
  },
  {
    id: "37126",
    roundname: "Round 5",
    hteam: "Adelaide",
    ateam: "Geelong",
    aflid: "6999",
  },
  {
    id: "37127",
    roundname: "Round 5",
    hteam: "Collingwood",
    ateam: "Sydney",
    aflid: "7000",
  },
  {
    id: "37128",
    roundname: "Round 5",
    hteam: "North Melbourne",
    ateam: "Gold Coast",
    aflid: "7003",
  },
  {
    id: "37129",
    roundname: "Round 5",
    hteam: "Carlton",
    ateam: "West Coast",
    aflid: "7005",
  },
  {
    id: "37130",
    roundname: "Round 5",
    hteam: "Western Bulldogs",
    ateam: "Brisbane Lions",
    aflid: "7004",
  },
  {
    id: "37131",
    roundname: "Round 5",
    hteam: "Melbourne",
    ateam: "Essendon",
    aflid: "7006",
  },
  {
    id: "37132",
    roundname: "Round 5",
    hteam: "Richmond",
    ateam: "Fremantle",
    aflid: "7009",
  },
  {
    id: "37133",
    roundname: "Round 5",
    hteam: "St Kilda",
    ateam: "Greater Western Sydney",
    aflid: "7007",
  },
  {
    id: "37134",
    roundname: "Round 5",
    hteam: "Port Adelaide",
    ateam: "Hawthorn",
    aflid: "7008",
  },
  {
    id: "37135",
    roundname: "Round 6",
    hteam: "Brisbane Lions",
    ateam: "Collingwood",
    aflid: "7010",
  },
  {
    id: "37136",
    roundname: "Round 6",
    hteam: "North Melbourne",
    ateam: "Carlton",
    aflid: "7011",
  },
  {
    id: "37137",
    roundname: "Round 6",
    hteam: "West Coast",
    ateam: "Essendon",
    aflid: "7012",
  },
  {
    id: "37138",
    roundname: "Round 6",
    hteam: "Melbourne",
    ateam: "Fremantle",
    aflid: "7015",
  },
  {
    id: "37139",
    roundname: "Round 6",
    hteam: "Adelaide",
    ateam: "Greater Western Sydney",
    aflid: "7013",
  },
  {
    id: "37140",
    roundname: "Round 6",
    hteam: "Richmond",
    ateam: "Gold Coast",
    aflid: "7018",
  },
  {
    id: "37141",
    roundname: "Round 6",
    hteam: "Sydney",
    ateam: "Port Adelaide",
    aflid: "7014",
  },
  {
    id: "37142",
    roundname: "Round 6",
    hteam: "Western Bulldogs",
    ateam: "St Kilda",
    aflid: "7019",
  },
  {
    id: "37143",
    roundname: "Round 6",
    hteam: "Geelong",
    ateam: "Hawthorn",
    aflid: "7017",
  },
  {
    id: "37144",
    roundname: "Round 7",
    hteam: "Melbourne",
    ateam: "Richmond",
    aflid: "7016",
  },
  {
    id: "37145",
    roundname: "Round 7",
    hteam: "Collingwood",
    ateam: "Essendon",
    aflid: "7032",
  },
  {
    id: "37146",
    roundname: "Round 7",
    hteam: "Fremantle",
    ateam: "Adelaide",
    aflid: "7020",
  },
  {
    id: "37147",
    roundname: "Round 7",
    hteam: "St Kilda",
    ateam: "Brisbane Lions",
    aflid: "7021",
  },
  {
    id: "37148",
    roundname: "Round 7",
    hteam: "Port Adelaide",
    ateam: "North Melbourne",
    aflid: "7031",
  },
  {
    id: "37149",
    roundname: "Round 7",
    hteam: "Greater Western Sydney",
    ateam: "Western Bulldogs",
    aflid: "7024",
  },
  {
    id: "37150",
    roundname: "Round 7",
    hteam: "Gold Coast",
    ateam: "Sydney",
    aflid: "7022",
  },
  {
    id: "37151",
    roundname: "Round 7",
    hteam: "Carlton",
    ateam: "Geelong",
    aflid: "7023",
  },
  {
    id: "37152",
    roundname: "Round 7",
    hteam: "Hawthorn",
    ateam: "West Coast",
    aflid: "7025",
  },
  {
    id: "37153",
    roundname: "Round 8",
    hteam: "Essendon",
    ateam: "North Melbourne",
    aflid: "7028",
  },
  {
    id: "37154",
    roundname: "Round 8",
    hteam: "St Kilda",
    ateam: "Fremantle",
    aflid: "7026",
  },
  {
    id: "37155",
    roundname: "Round 8",
    hteam: "Western Bulldogs",
    ateam: "Port Adelaide",
    aflid: "7027",
  },
  {
    id: "37156",
    roundname: "Round 8",
    hteam: "Adelaide",
    ateam: "Carlton",
    aflid: "7029",
  },
  {
    id: "37157",
    roundname: "Round 8",
    hteam: "Collingwood",
    ateam: "Geelong",
    aflid: "7030",
  },
  {
    id: "37158",
    roundname: "Round 8",
    hteam: "West Coast",
    ateam: "Melbourne",
    aflid: "7039",
  },
  {
    id: "37159",
    roundname: "Round 8",
    hteam: "Sydney",
    ateam: "Greater Western Sydney",
    aflid: "7034",
  },
  {
    id: "37160",
    roundname: "Round 8",
    hteam: "Hawthorn",
    ateam: "Richmond",
    aflid: "7033",
  },
  {
    id: "37161",
    roundname: "Round 8",
    hteam: "Brisbane Lions",
    ateam: "Gold Coast",
    aflid: "7035",
  },
  {
    id: "37162",
    roundname: "Round 9",
    hteam: "Fremantle",
    ateam: "Collingwood",
    aflid: "7038",
  },
  {
    id: "37163",
    roundname: "Round 9",
    hteam: "St Kilda",
    ateam: "Carlton",
    aflid: "7037",
  },
  {
    id: "37164",
    roundname: "Round 9",
    hteam: "Melbourne",
    ateam: "Hawthorn",
    aflid: "7041",
  },
  {
    id: "37165",
    roundname: "Round 9",
    hteam: "Essendon",
    ateam: "Sydney",
    aflid: "7036",
  },
  {
    id: "37166",
    roundname: "Round 9",
    hteam: "Gold Coast",
    ateam: "Western Bulldogs",
    aflid: "7043",
  },
  {
    id: "37167",
    roundname: "Round 9",
    hteam: "Port Adelaide",
    ateam: "Adelaide",
    aflid: "7044",
  },
  {
    id: "37168",
    roundname: "Round 9",
    hteam: "Richmond",
    ateam: "West Coast",
    aflid: "7040",
  },
  {
    id: "37169",
    roundname: "Round 9",
    hteam: "Geelong",
    ateam: "Greater Western Sydney",
    aflid: "7042",
  },
  {
    id: "37170",
    roundname: "Round 9",
    hteam: "North Melbourne",
    ateam: "Brisbane Lions",
    aflid: "7045",
  },
  {
    id: "37171",
    roundname: "Round 10",
    hteam: "Gold Coast",
    ateam: "Hawthorn",
    aflid: "7050",
  },
  {
    id: "37172",
    roundname: "Round 10",
    hteam: "Sydney",
    ateam: "Carlton",
    aflid: "7046",
  },
  {
    id: "37173",
    roundname: "Round 10",
    hteam: "Collingwood",
    ateam: "Adelaide",
    aflid: "7047",
  },
  {
    id: "37175",
    roundname: "Round 10",
    hteam: "Greater Western Sydney",
    ateam: "Fremantle",
    aflid: "7049",
  },
  {
    id: "37174",
    roundname: "Round 10",
    hteam: "Port Adelaide",
    ateam: "Geelong",
    aflid: "7054",
  },
  {
    id: "37176",
    roundname: "Round 10",
    hteam: "Western Bulldogs",
    ateam: "Essendon",
    aflid: "7048",
  },
  {
    id: "37177",
    roundname: "Round 10",
    hteam: "Richmond",
    ateam: "North Melbourne",
    aflid: "7053",
  },
  {
    id: "37178",
    roundname: "Round 10",
    hteam: "Brisbane Lions",
    ateam: "Melbourne",
    aflid: "7061",
  },
  {
    id: "37179",
    roundname: "Round 10",
    hteam: "West Coast",
    ateam: "St Kilda",
    aflid: "7051",
  },
  {
    id: "37180",
    roundname: "Round 11",
    hteam: "Geelong",
    ateam: "Western Bulldogs",
    aflid: "7052",
  },
  {
    id: "37181",
    roundname: "Round 11",
    hteam: "Essendon",
    ateam: "Richmond",
    aflid: "7056",
  },
  {
    id: "37182",
    roundname: "Round 11",
    hteam: "Carlton",
    ateam: "Greater Western Sydney",
    aflid: "7055",
  },
  {
    id: "37183",
    roundname: "Round 11",
    hteam: "Hawthorn",
    ateam: "Brisbane Lions",
    aflid: "7058",
  },
  {
    id: "37184",
    roundname: "Round 11",
    hteam: "North Melbourne",
    ateam: "Collingwood",
    aflid: "7059",
  },
  {
    id: "37185",
    roundname: "Round 11",
    hteam: "Fremantle",
    ateam: "Port Adelaide",
    aflid: "7062",
  },
  {
    id: "37186",
    roundname: "Round 11",
    hteam: "Adelaide",
    ateam: "West Coast",
    aflid: "7060",
  },
  {
    id: "37187",
    roundname: "Round 11",
    hteam: "Melbourne",
    ateam: "Sydney",
    aflid: "7057",
  },
  {
    id: "37188",
    roundname: "Round 11",
    hteam: "St Kilda",
    ateam: "Gold Coast",
    aflid: "7064",
  },
  {
    id: "37189",
    roundname: "Round 12",
    hteam: "Brisbane Lions",
    ateam: "Essendon",
    aflid: "7063",
  },
  {
    id: "37190",
    roundname: "Round 12",
    hteam: "Collingwood",
    ateam: "Hawthorn",
    aflid: "7065",
  },
  {
    id: "37191",
    roundname: "Round 12",
    hteam: "Gold Coast",
    ateam: "Fremantle",
    aflid: "7067",
  },
  {
    id: "37192",
    roundname: "Round 12",
    hteam: "Greater Western Sydney",
    ateam: "Richmond",
    aflid: "7066",
  },
  {
    id: "37193",
    roundname: "Round 12",
    hteam: "Sydney",
    ateam: "Adelaide",
    aflid: "7072",
  },
  {
    id: "37194",
    roundname: "Round 12",
    hteam: "Melbourne",
    ateam: "St Kilda",
    aflid: "7068",
  },
  {
    id: "37195",
    roundname: "Round 12",
    hteam: "West Coast",
    ateam: "Geelong",
    aflid: "7069",
  },
  {
    id: "37196",
    roundname: "Round 13",
    hteam: "Western Bulldogs",
    ateam: "Hawthorn",
    aflid: "7070",
  },
  {
    id: "37197",
    roundname: "Round 13",
    hteam: "Adelaide",
    ateam: "Brisbane Lions",
    aflid: "7076",
  },
  {
    id: "37198",
    roundname: "Round 13",
    hteam: "Richmond",
    ateam: "Sydney",
    aflid: "7078",
  },
  {
    id: "37199",
    roundname: "Round 13",
    hteam: "Geelong",
    ateam: "Gold Coast",
    aflid: "7071",
  },
  {
    id: "37200",
    roundname: "Round 13",
    hteam: "Greater Western Sydney",
    ateam: "Port Adelaide",
    aflid: "7074",
  },
  {
    id: "37201",
    roundname: "Round 13",
    hteam: "North Melbourne",
    ateam: "West Coast",
    aflid: "7075",
  },
  {
    id: "37202",
    roundname: "Round 13",
    hteam: "Carlton",
    ateam: "Essendon",
    aflid: "7077",
  },
  {
    id: "37203",
    roundname: "Round 13",
    hteam: "Melbourne",
    ateam: "Collingwood",
    aflid: "7073",
  },
  {
    id: "37204",
    roundname: "Round 14",
    hteam: "St Kilda",
    ateam: "Western Bulldogs",
    aflid: "7079",
  },
  {
    id: "37205",
    roundname: "Round 14",
    hteam: "Hawthorn",
    ateam: "Adelaide",
    aflid: "7081",
  },
  {
    id: "37206",
    roundname: "Round 14",
    hteam: "Brisbane Lions",
    ateam: "Greater Western Sydney",
    aflid: "7080",
  },
  {
    id: "37207",
    roundname: "Round 14",
    hteam: "Essendon",
    ateam: "Geelong",
    aflid: "7082",
  },
  {
    id: "37208",
    roundname: "Round 14",
    hteam: "North Melbourne",
    ateam: "Fremantle",
    aflid: "7087",
  },
  {
    id: "37209",
    roundname: "Round 14",
    hteam: "Port Adelaide",
    ateam: "Melbourne",
    aflid: "7083",
  },
  {
    id: "37210",
    roundname: "Round 14",
    hteam: "West Coast",
    ateam: "Carlton",
    aflid: "7099",
  },
  {
    id: "37211",
    roundname: "Round 15",
    hteam: "Fremantle",
    ateam: "Essendon",
    aflid: "7084",
  },
  {
    id: "37212",
    roundname: "Round 15",
    hteam: "Geelong",
    ateam: "Brisbane Lions",
    aflid: "7098",
  },
  {
    id: "37213",
    roundname: "Round 15",
    hteam: "Carlton",
    ateam: "North Melbourne",
    aflid: "7085",
  },
  {
    id: "37214",
    roundname: "Round 15",
    hteam: "Port Adelaide",
    ateam: "Sydney",
    aflid: "7089",
  },
  {
    id: "37215",
    roundname: "Round 15",
    hteam: "Collingwood",
    ateam: "St Kilda",
    aflid: "7086",
  },
  {
    id: "37216",
    roundname: "Round 15",
    hteam: "Greater Western Sydney",
    ateam: "Gold Coast",
    aflid: "7088",
  },
  {
    id: "37217",
    roundname: "Round 15",
    hteam: "Western Bulldogs",
    ateam: "Richmond",
    aflid: "7093",
  },
  {
    id: "37223",
    roundname: "Round 16",
    hteam: "Port Adelaide",
    ateam: "Carlton",
    aflid: "7095",
  },
  {
    id: "37221",
    roundname: "Round 16",
    hteam: "Sydney",
    ateam: "Western Bulldogs",
    aflid: "7092",
  },
  {
    id: "37220",
    roundname: "Round 16",
    hteam: "Gold Coast",
    ateam: "Melbourne",
    aflid: "7116",
  },
  {
    id: "37222",
    roundname: "Round 16",
    hteam: "Hawthorn",
    ateam: "North Melbourne",
    aflid: "7091",
  },
  {
    id: "37218",
    roundname: "Round 16",
    hteam: "Collingwood",
    ateam: "West Coast",
    aflid: "7090",
  },
  {
    id: "37219",
    roundname: "Round 16",
    hteam: "Richmond",
    ateam: "Adelaide",
    aflid: "7094",
  },
  {
    id: "37224",
    roundname: "Round 16",
    hteam: "Fremantle",
    ateam: "St Kilda",
    aflid: "7096",
  },
  {
    id: "37227",
    roundname: "Round 17",
    hteam: "North Melbourne",
    ateam: "Western Bulldogs",
    aflid: "7101",
  },
  {
    id: "37229",
    roundname: "Round 17",
    hteam: "Carlton",
    ateam: "Collingwood",
    aflid: "7097",
  },
  {
    id: "37233",
    roundname: "Round 17",
    hteam: "West Coast",
    ateam: "Greater Western Sydney",
    aflid: "7104",
  },
  {
    id: "37228",
    roundname: "Round 17",
    hteam: "Essendon",
    ateam: "Gold Coast",
    aflid: "7100",
  },
  {
    id: "37225",
    roundname: "Round 17",
    hteam: "Geelong",
    ateam: "Richmond",
    aflid: "7112",
  },
  {
    id: "37231",
    roundname: "Round 17",
    hteam: "Brisbane Lions",
    ateam: "Port Adelaide",
    aflid: "7105",
  },
  {
    id: "37226",
    roundname: "Round 17",
    hteam: "St Kilda",
    ateam: "Hawthorn",
    aflid: "7102",
  },
  {
    id: "37230",
    roundname: "Round 17",
    hteam: "Sydney",
    ateam: "Fremantle",
    aflid: "7103",
  },
  {
    id: "37232",
    roundname: "Round 17",
    hteam: "Adelaide",
    ateam: "Melbourne",
    aflid: "7106",
  },
  {
    id: "37237",
    roundname: "Round 18",
    hteam: "Carlton",
    ateam: "Brisbane Lions",
    aflid: "7113",
  },
  {
    id: "37240",
    roundname: "Round 18",
    hteam: "Gold Coast",
    ateam: "Collingwood",
    aflid: "7109",
  },
  {
    id: "37235",
    roundname: "Round 18",
    hteam: "Western Bulldogs",
    ateam: "Adelaide",
    aflid: "7111",
  },
  {
    id: "37234",
    roundname: "Round 18",
    hteam: "Greater Western Sydney",
    ateam: "Geelong",
    aflid: "7110",
  },
  {
    id: "37239",
    roundname: "Round 18",
    hteam: "Richmond",
    ateam: "Essendon",
    aflid: "7107",
  },
  {
    id: "37242",
    roundname: "Round 18",
    hteam: "Fremantle",
    ateam: "Hawthorn",
    aflid: "7126",
  },
  {
    id: "37238",
    roundname: "Round 18",
    hteam: "Melbourne",
    ateam: "North Melbourne",
    aflid: "7108",
  },
  {
    id: "37236",
    roundname: "Round 18",
    hteam: "St Kilda",
    ateam: "Sydney",
    aflid: "7118",
  },
  {
    id: "37241",
    roundname: "Round 18",
    hteam: "Port Adelaide",
    ateam: "West Coast",
    aflid: "7115",
  },
  {
    id: "37244",
    roundname: "Round 19",
    hteam: "Essendon",
    ateam: "Greater Western Sydney",
    aflid: "7124",
  },
  {
    id: "37248",
    roundname: "Round 19",
    hteam: "Brisbane Lions",
    ateam: "Western Bulldogs",
    aflid: "7127",
  },
  {
    id: "37249",
    roundname: "Round 19",
    hteam: "Hawthorn",
    ateam: "Port Adelaide",
    aflid: "7119",
  },
  {
    id: "37247",
    roundname: "Round 19",
    hteam: "Sydney",
    ateam: "North Melbourne",
    aflid: "7120",
  },
  {
    id: "37245",
    roundname: "Round 19",
    hteam: "Carlton",
    ateam: "Melbourne",
    aflid: "7114",
  },
  {
    id: "37251",
    roundname: "Round 19",
    hteam: "West Coast",
    ateam: "Richmond",
    aflid: "7122",
  },
  {
    id: "37243",
    roundname: "Round 19",
    hteam: "Geelong",
    ateam: "St Kilda",
    aflid: "7129",
  },
  {
    id: "37246",
    roundname: "Round 19",
    hteam: "Collingwood",
    ateam: "Fremantle",
    aflid: "7117",
  },
  {
    id: "37250",
    roundname: "Round 19",
    hteam: "Adelaide",
    ateam: "Gold Coast",
    aflid: "7121",
  },
  {
    id: "37257",
    roundname: "Round 20",
    hteam: "Hawthorn",
    ateam: "Carlton",
    aflid: "7123",
  },
  {
    id: "37255",
    roundname: "Round 20",
    hteam: "Essendon",
    ateam: "Western Bulldogs",
    aflid: "7125",
  },
  {
    id: "37252",
    roundname: "Round 20",
    hteam: "Greater Western Sydney",
    ateam: "Sydney",
    aflid: "7136",
  },
  {
    id: "37258",
    roundname: "Round 20",
    hteam: "Gold Coast",
    ateam: "Brisbane Lions",
    aflid: "7132",
  },
  {
    id: "37260",
    roundname: "Round 20",
    hteam: "Fremantle",
    ateam: "West Coast",
    aflid: "7134",
  },
  {
    id: "37253",
    roundname: "Round 20",
    hteam: "North Melbourne",
    ateam: "Geelong",
    aflid: "7128",
  },
  {
    id: "37259",
    roundname: "Round 20",
    hteam: "Adelaide",
    ateam: "Port Adelaide",
    aflid: "7142",
  },
  {
    id: "37256",
    roundname: "Round 20",
    hteam: "Richmond",
    ateam: "Collingwood",
    aflid: "7131",
  },
  {
    id: "37254",
    roundname: "Round 20",
    hteam: "St Kilda",
    ateam: "Melbourne",
    aflid: "7130",
  },
  {
    id: "37264",
    roundname: "Round 21",
    hteam: "Western Bulldogs",
    ateam: "Greater Western Sydney",
    aflid: "7143",
  },
  {
    id: "37268",
    roundname: "Round 21",
    hteam: "Adelaide",
    ateam: "Hawthorn",
    aflid: "7139",
  },
  {
    id: "37263",
    roundname: "Round 21",
    hteam: "Melbourne",
    ateam: "West Coast",
    aflid: "7141",
  },
  {
    id: "37266",
    roundname: "Round 21",
    hteam: "Gold Coast",
    ateam: "Richmond",
    aflid: "7138",
  },
  {
    id: "37267",
    roundname: "Round 21",
    hteam: "Sydney",
    ateam: "Essendon",
    aflid: "7140",
  },
  {
    id: "37265",
    roundname: "Round 21",
    hteam: "Collingwood",
    ateam: "Brisbane Lions",
    aflid: "7133",
  },
  {
    id: "37262",
    roundname: "Round 21",
    hteam: "St Kilda",
    ateam: "North Melbourne",
    aflid: "7137",
  },
  {
    id: "37261",
    roundname: "Round 21",
    hteam: "Geelong",
    ateam: "Port Adelaide",
    aflid: "7135",
  },
  {
    id: "37269",
    roundname: "Round 21",
    hteam: "Fremantle",
    ateam: "Carlton",
    aflid: "7144",
  },
  {
    id: "37275",
    roundname: "Round 22",
    hteam: "Hawthorn",
    ateam: "Collingwood",
    aflid: "7150",
  },
  {
    id: "37270",
    roundname: "Round 22",
    hteam: "Geelong",
    ateam: "Essendon",
    aflid: "7152",
  },
  {
    id: "37273",
    roundname: "Round 22",
    hteam: "Richmond",
    ateam: "St Kilda",
    aflid: "7147",
  },
  {
    id: "37276",
    roundname: "Round 22",
    hteam: "Brisbane Lions",
    ateam: "Sydney",
    aflid: "7145",
  },
  {
    id: "37272",
    roundname: "Round 22",
    hteam: "Carlton",
    ateam: "Gold Coast",
    aflid: "7149",
  },
  {
    id: "37277",
    roundname: "Round 22",
    hteam: "Port Adelaide",
    ateam: "Fremantle",
    aflid: "7151",
  },
  {
    id: "37271",
    roundname: "Round 22",
    hteam: "Greater Western Sydney",
    ateam: "North Melbourne",
    aflid: "7148",
  },
  {
    id: "37274",
    roundname: "Round 22",
    hteam: "Melbourne",
    ateam: "Western Bulldogs",
    aflid: "7146",
  },
  {
    id: "37278",
    roundname: "Round 22",
    hteam: "West Coast",
    ateam: "Adelaide",
    aflid: "7153",
  },
  {
    id: "37280",
    roundname: "Round 23",
    hteam: "Essendon",
    ateam: "St Kilda",
    aflid: "7154",
  },
  {
    id: "37287",
    roundname: "Round 23",
    hteam: "Fremantle",
    ateam: "Brisbane Lions",
    aflid: "7160",
  },
  {
    id: "37284",
    roundname: "Round 23",
    hteam: "Gold Coast",
    ateam: "Greater Western Sydney",
    aflid: "7162",
  },
  {
    id: "37282",
    roundname: "Round 23",
    hteam: "Carlton",
    ateam: "Port Adelaide",
    aflid: "7155",
  },
  {
    id: "37283",
    roundname: "Round 23",
    hteam: "Hawthorn",
    ateam: "Melbourne",
    aflid: "7157",
  },
  {
    id: "37286",
    roundname: "Round 23",
    hteam: "Adelaide",
    ateam: "Collingwood",
    aflid: "7161",
  },
  {
    id: "37279",
    roundname: "Round 23",
    hteam: "North Melbourne",
    ateam: "Richmond",
    aflid: "7156",
  },
  {
    id: "37285",
    roundname: "Round 23",
    hteam: "Sydney",
    ateam: "Geelong",
    aflid: "7159",
  },
  {
    id: "37281",
    roundname: "Round 23",
    hteam: "Western Bulldogs",
    ateam: "West Coast",
    aflid: "7158",
  },
  {
    id: "37294",
    roundname: "Round 24",
    hteam: "Brisbane Lions",
    ateam: "Hawthorn",
    aflid: "7163",
  },
  {
    id: "37291",
    roundname: "Round 24",
    hteam: "Collingwood",
    ateam: "Melbourne",
    aflid: "7165",
  },
  {
    id: "37293",
    roundname: "Round 24",
    hteam: "Essendon",
    ateam: "Carlton",
    aflid: "7164",
  },
  {
    id: "37092",
    roundname: "Round 24",
    hteam: "Gold Coast",
    ateam: "Essendon",
    aflid: "7754",
  },
  {
    id: "37288",
    roundname: "Round 24",
    hteam: "Greater Western Sydney",
    ateam: "St Kilda",
    aflid: "7168",
  },
  {
    id: "37289",
    roundname: "Round 24",
    hteam: "North Melbourne",
    ateam: "Adelaide",
    aflid: "7166",
  },
  {
    id: "37292",
    roundname: "Round 24",
    hteam: "Richmond",
    ateam: "Geelong",
    aflid: "7167",
  },
  {
    id: "37290",
    roundname: "Round 24",
    hteam: "Western Bulldogs",
    ateam: "Fremantle",
    aflid: "7171",
  },
  {
    id: "37295",
    roundname: "Round 24",
    hteam: "Port Adelaide",
    ateam: "Gold Coast",
    aflid: "7169",
  },
  {
    id: "37296",
    roundname: "Round 24",
    hteam: "West Coast",
    ateam: "Sydney",
    aflid: "7170",
  },
];

export default matchReference;
